import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import LogMain from "../../components/logMain";



const LogPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Вход')}/>
            <LogMain/>
        </section>
    );
};

export default LogPage;